/* tslint:disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration for FileManagementApi services
 */
@Injectable({
  providedIn: 'root',
})
export class FileManagementApiConfiguration {
  rootUrl: string = '';
}

export interface FileManagementApiConfigurationInterface {
  rootUrl?: string;
}
